import {
    RouteLocationInterface,
    RouteHttpVerb,
    RouteResponseInterface,
    RouteRequestInterface,
    RouteParamsInterface
} from "@wpnotes/utils";
import { TodoModel } from "../models";

export const locationRestTodoPost: RouteLocationInterface = {
    path: "/todo",
    method: RouteHttpVerb.POST
};

export type RequestRouteTodoPost = RouteRequestInterface;

export type ParamsRouteTodoPost = RouteParamsInterface;

export interface ResponseRouteTodoPost extends RouteResponseInterface {
    data: TodoModel[];
    errors?: string[];
}
